import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "cy-node-subtitle",
  "data-cy": "tree-node-name"
}

import { computed, ref } from "vue";
import { NodeDisplayProps } from "@/types";
import { timStore } from "@/hooks";
import { Separator, Typography, Icon, FlexBox } from "@/components/common";


/**
 * A generic node display for the graph.
 */
const __default__ = {
  name: "NodeDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    variant: {},
    color: {},
    title: {},
    subtitle: {},
    separator: { type: Boolean },
    body: {},
    selected: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const mouseDownTime = ref(0);
const mouseUpTime = ref(0);

const className = computed(
  () =>
    "cy-node-display " +
    (props.selected ? "cy-node-selected " : "") +
    (props.color.includes("#") ? "" : `bd-${props.color} `) +
    {
      tim: "cy-node-tim q-px-lg q-py-md",
      artifact: "cy-node-artifact q-pa-sm",
      footer: "cy-node-footer q-pa-xs",
      sidebar: "cy-node-sidebar q-pa-xs",
      menu: "cy-node-menu q-pa-xs",
    }[props.variant]
);

const separatorClassName = computed(
  () =>
    "cy-node-separator " +
    (props.color.includes("#") ? "" : `bg-${props.color} `) +
    (props.variant !== "tim" ? "q-mt-xs q-mb-none" : "q-my-sm")
);

const cardStyle = computed(() =>
  props.color.includes("#") ? `border-color: ${props.color};` : undefined
);
const separatorStyle = computed(() =>
  props.color.includes("#") ? `background-color: ${props.color};` : undefined
);

const iconId = computed(() =>
  props.title ? timStore.getTypeIcon(props.title) : undefined
);

const iconColor = computed(() =>
  props.title ? timStore.getTypeColor(props.title) : undefined
);

/**
 * Handles a click event, as long as it isn't a drag event.
 */
function handleClick(): void {
  if (mouseUpTime.value - mouseDownTime.value > 200) return;

  emit("click");
}

return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    flat: "",
    bordered: "",
    class: _normalizeClass(className.value),
    style: _normalizeStyle(cardStyle.value),
    onMousedown: _cache[0] || (_cache[0] = ($event: any) => (mouseDownTime.value = new Date().getTime())),
    onMouseup: _cache[1] || (_cache[1] = ($event: any) => (mouseUpTime.value = new Date().getTime())),
    onClick: handleClick,
    onTouchend: handleClick
  }, {
    default: _withCtx(() => [
      (props.title)
        ? (_openBlock(), _createBlock(_unref(FlexBox), {
            key: 0,
            class: "cy-node-title",
            justify: "center",
            align: "center",
            "data-cy": "tree-node-type"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Icon), {
                id: iconId.value,
                color: iconColor.value,
                size: "sm"
              }, null, 8, ["id", "color"]),
              _createVNode(_unref(Typography), {
                variant: "subtitle",
                value: props.title,
                bold: "",
                l: "1",
                align: "center",
                ellipsis: "",
                color: "text"
              }, null, 8, ["value"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (props.separator)
        ? (_openBlock(), _createBlock(_unref(Separator), {
            key: 1,
            style: _normalizeStyle(separatorStyle.value),
            class: _normalizeClass(separatorClassName.value)
          }, null, 8, ["style", "class"]))
        : _createCommentVNode("", true),
      (!!props.subtitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Typography), {
              variant: "subtitle",
              value: props.subtitle
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      (!!props.body)
        ? (_openBlock(), _createBlock(_unref(Typography), {
            key: 3,
            value: props.body
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "style"]))
}
}

})